/**
 * Helper
 */
var helper = require('../../helper');

function PropertyViewingOfPropertyDataTable() {
    this.dataTables_buttons = [
        {
            extend: 'csv',
            text: 'Export as CSV',
            exportOptions: {
                columns: [0, 1, 2, 3, 4, 5, 6, 7]
            },
            className: 'btn btn-default'
        },
        {
            extend: 'pdf',
            text: 'Export as PDF',
            exportOptions: {
                columns: [0, 1, 2, 3, 4, 5, 6, 7]
            },
            className: 'btn btn-default'
        },
        {
            extend: 'colvis',
            className: 'btn btn-default'
            //     columns: ':gt(0)'
        }

    ];

    this.$field = $('#datatable-property-viewings-of-property');
    this.propertyId =  this.$field.data('property');
    this.$overviewBox = $('.js-property-viewing-overview-box');

    this.table = this.$field.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "buttons": this.dataTables_buttons,
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [[ 30, 10, 25, 50, 75, 100, -1], [ 30, 10, 25, 50, 75, 100, "All"]],
       /** "ajax": helper.getOrigin() + "/api/property_viewings/property-dt/" + this.propertyId,*/
        "ajax": {
            "url": helper.getOrigin() + "/api/property_viewings/property-dt/" + this.propertyId,
            "method": 'POST',
            "data": function ( d ) {
                d.status_id = $('input[name="clickedStatusId"]').val();
            }
        },
        "autoWidth" : false,
        "order": [[ 2, "asc" ]],
        "columns": [
            {data: 'first_name', name: 'user.first_name'},
            {data: 'last_name', name: 'user.last_name'},
            {data: 'day', name: 'date'},
            {data: 'time_from', name: 'time_from'},
            {data: 'time_to', name: 'time_to'},
            {data: 'confirmed', name: 'confirmed', orderable: false, searchable: false, width: '1%', className : "centerize"},
            {data: 'attendees', name: 'attendees'},
            {data: 'rooms_taken', name: 'rooms_taken'},
            {data: 'calendar', name: 'calendar', orderable: false, searchable: false, className : "action"},
            {data: 'actions', name: 'actions', orderable: false, searchable: false, className : "action"}
        ],
        "initComplete": function(settings, json) {
            // init callback
        }
    });


    var self = this;

    this.$overviewBox.on('click', function() {
        var $this = $(this),
            $clickedStatusId = $('input[name="clickedStatusId"]'),
            statusId = $(this).data('status_id');

        $clickedStatusId.val( statusId );

        console.log('click status!');
        console.log( statusId);

        self.table.ajax.reload();
    });
}

PropertyViewingOfPropertyDataTable.prototype.reload = function() {
    var self = this;
    self.table.ajax.reload();
}

module.exports = PropertyViewingOfPropertyDataTable;
